// @flow

import type { Action } from "redux-action";
import { beginRequest, completeRequest } from "@store/utils";

import type { ApprovableContainer } from "@modules/service/types";
import type { AlertsState, Alert } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

// Get  List

export const onUpdateAlert = (state: AlertsState) => () => startRequest(state);
export const onUpdateAlertSuccess = (state: AlertsState) => () => finishRequest(state);
export const onUpdateAlertError = (state: AlertsState) => () => finishRequest(state);

export const onGetAlertsList = (state: AlertsState) => () => startRequest(state);

export const onGetAlertsListSuccess = (state: AlertsState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    list: payload,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  };
};

export const onAddAlert = (state: AlertsState) => ({ payload }: Object) => {
  return { ...state, ...startRequest(state) };
};
export const onAddAlertSuccess = (state: AlertsState) => ({ payload }: Object) => {
  let list = state.list || [];
  list.push(payload);
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    list,
  };
};

export const onGetAlertsListError = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get  Record

export const onGetAlert = (state: AlertsState) => () => startRequest(state);

export const onGetAlertSuccess = (state: AlertsState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    current: payload,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  };
};

export const onGetAlertError = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get  Schema

export const onGetSchema = (state: AlertsState) => () => startRequest(state);

export const onGetSchemaSuccess = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onGetSchemaError = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Create

export const onNew = (state: AlertsState) => (action: Action<void>) => ({
  ...state,
  draft: {
    details: {},
  },
});

export const onStartDraftSuccess = (state: AlertsState) => (
  action: Action<ApprovableContainer<Alert>>,
) => ({
  ...state,
  draft: (action.payload && action.payload.active) || {},
});

export const onDuplicateSuccess = (state: AlertsState) => (action: Action<Alert>) => ({
  ...state,
  draft: action.payload,
});

export const onSetDraft = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  draft: payload,
});

export const onNewAssignments = (state: AlertsState) => (action: Action<void>) => ({
  ...state,
  assignments: [],
});

export const onSetAssignments = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  assignments: payload,
});

export const onSetAlertDraftAssignments = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  draftAssignments: payload,
});

// Config

export const onSetEnabled = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  configuration: {
    ...state.configuration,
    enabled: payload,
  },
});

export const onSetStatus = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  configuration: {
    ...state.configuration,
    status: payload,
  },
});

// Modals

export const onSetModalStep = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    modalStep: payload,
  },
});

export const onSetShowAddModal = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddModal: payload,
  },
});

export const onSetShowEditModal = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditModal: payload,
  },
});

export const onSetShowEditAssignmentsModal = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditAssignmentsModal: payload,
  },
});

export const onSetShowAddAlertRecipientModal = (state: AlertsState) => ({ payload }: any) => {
  state.modals.showAddAlertRecipientModal = payload;
  return state;
};

export const onSetShowDeleteAlertRecipientModal = (state: AlertsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDeleteAlertRecipientModal: payload,
  },
});

export const onSetShowDiscardModal = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDiscardModal: payload,
  },
});

export const onSetShowSubmitModal = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showSubmitModal: payload,
  },
});

export const onSetShowCancelModal = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showCancelModal: payload,
  },
});

export const onSetShowCancelDiscardModal = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showCancelDiscardModal: payload,
  },
});

export const onSetShowDisableModal = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDisableModal: payload,
  },
});

export const onSetShowAddAlertAttachmentModal = (state: AlertsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddAlertAttachmentModal: payload,
  },
});

export const onSetShowDeleteAlertAttachmentModal = (state: AlertsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDeleteAlertAttachmentModal: payload,
  },
});
